import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 18 14.99',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g id="restart">
      <path
        d="M7.486 14.991A7.5 7.5 0 0 1 7.486 0a7.718 7.718 0 0 1 7.486 7.236l.036.627L17 5.874l1 .977-3.994 3.922-4.12-3.985L11 5.857l2.221 2.185-.018-.7a5.741 5.741 0 1 0-5.731 5.839 5.869 5.869 0 0 0 2.579-.609L11 14.131a7.757 7.757 0 0 1-3.514.86z"
        fill={fill}
      />
    </g>
  </svg>
);
export default SVG;
